<template>
  <div
    class="keyword-column-settings-item"
    :class="{ 'keyword-column-settings-item--locked': isLocked }"
  >
    <i class="material-icons keyword-column-settings-item__icon">
      {{ icon }}
    </i>
    <div class="keyword-column-settings-item__text">
      {{ columnName }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeywordColumnSettingsItem',
  props: {
    isLocked: {
      type: Boolean,
      default: false,
    },
    columnName: {
      type: String,
      required: true,
    },
  },
  computed: {
    icon() {
      return this.isLocked ? 'lock' : 'drag_handle';
    },
  },
};
</script>

<style lang="scss">
.keyword-column-settings-item {
  background-color: $lb-color-primary;
  color: #fff;

  border-radius: $lb-border-radius;

  padding: $global-padding / 2;

  display: flex;
  align-items: center;

  user-select: none;

  &--locked {
    background-color: $lb-dark-gray;
  }

  &__text {
    flex: 1;

    margin-left: calc($global-margin / 2);

    @include rtl() {
      margin-left: 0;
      margin-right: calc($global-margin / 2);
    }
  }

  &__icon {
    font-size: $lb-global-font-size * 1.3;
  }
}
</style>
